import { IOption } from './IOption'
import { IPropertyFilter } from './IPropertyFilter'

export type SingleSelect = IOption | null

export const isValidSingleSelect = (value: SingleSelect) => value !== null

export interface ISingleSelectFilter<T> extends IPropertyFilter<T> {
  type: 'singleSelect'
  value: SingleSelect
  propertyIsString: boolean
}

export const isSingleSelectFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is ISingleSelectFilter<T> => filter.type === 'singleSelect'

export const normalizeSingleSelectFilter = <T>({
  propertyName,
  propertyIsString,
  value,
}: ISingleSelectFilter<T>): string =>
  !!value
    ? `(${String(propertyName)} eq ${
        propertyIsString ? `'${value.value}'` : value.value
      })`
    : ''
